export default __webpack_public_path__ + "static/media/skill_4.5a7287d8.png";